import {
  List,
  Datagrid,
  TextField,
  UrlField,
  BulkDeleteButton,
  usePermissions,
} from "react-admin";
import { Box, Typography } from "@mui/material";

export const CertificateList = (props) => {
  const { permissions = [] } = usePermissions();

  return (
    <List title="Certificate" {...props}>
      <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Certificates
        </Typography>
      </Box>

      <Datagrid
        bulkActionButtons={
          permissions.includes("certificate.delete") ||
          permissions.includes("*")
            ? <BulkDeleteButton />
            : false
        }
      >
        <TextField source="id" />
        <TextField source="course_name" label="Certificate-Type" />
        <UrlField source="pdf_url" />
      </Datagrid>
    </List>
  );
};

export default CertificateList;